import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { uploadClass } from './styles';
import { accept as fileAccept } from '../utils';

var Drop =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Drop, _React$Component);

  var _super = _createSuper2(Drop);

  function Drop(props) {
    var _this;

    _classCallCheck(this, Drop);

    _this = _super.call(this, props);
    _this.state = {
      drop: false
    };
    _this.handleDrag = _this.handleDrag.bind(_assertThisInitialized(_this));
    _this.handleFileDrop = _this.handleFileDrop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Drop, [{
    key: "handleFileDrop",
    value: function handleFileDrop(e) {
      var files = e.dataTransfer.files;
      var _this$props = this.props,
          accept = _this$props.accept,
          multiple = _this$props.multiple,
          onDrop = _this$props.onDrop,
          dropData = _this$props.dropData;
      var filter = accept ? Array.prototype.filter.call(files, function (f) {
        return fileAccept(f, accept);
      }) : files;
      if (!filter || filter.length === 0) return;
      if (onDrop) onDrop(multiple ? filter : [filter[0]], dropData);
    }
  }, {
    key: "handleDrag",
    value: function handleDrag(e) {
      var disabled = this.props.disabled;
      if (disabled) return;
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        drop: e.type === 'dragover'
      });
      if (e.type === 'drop') this.handleFileDrop(e);
    }
  }, {
    key: "render",
    value: function render() {
      var drop = this.state.drop;
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className;
      if (!this.props.drop) return children;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          className: classnames(className, uploadClass(drop && 'drop')),
          onDragOver: this.handleDrag,
          onDragLeave: this.handleDrag,
          onDrop: this.handleDrag
        }, children)
      );
    }
  }]);

  return Drop;
}(React.Component);

Drop.defaultProps = {
  drop: false
};
export { Drop as default };